import type { InvestorDocument } from '../../data/investors/index'

export function InvestorDocumentCard({ document }: { document: InvestorDocument }) {
  return (
    <article className="ir-document">
      <span>{document.type.replace('-', ' ')}</span><h3>{document.title}</h3><p>{document.description}</p><dl><div><dt>Date</dt><dd>{document.date}</dd></div><div><dt>Version</dt><dd>{document.version ?? '—'}</dd></div><div><dt>Access</dt><dd>{document.access}</dd></div></dl>
      {document.file ? <a href={document.file} download>Download <i>↓</i></a> : <div>{document.access === 'restricted' ? 'Restricted / not published' : 'File unavailable'}</div>}
    </article>
  )
}
